module.exports = __webpack_public_path__ + "img/imag2.9cfca840.png";